import { IWPPostBase, WPPostBase, IModel } from "@/loader";

export interface IWPPage extends IWPPostBase {
	password?: string;
	parent?: number;
	menu_order?: number;
}

export class WPPage extends WPPostBase implements IWPPage, IModel<IWPPage> {
	public password!: string;
	public parent!: number;
	public menu_order!: number;

	public constructor(data: IWPPage = {}) {
		super();
		this.load(data);
	}

	public load(data: IWPPage) {
		super.load(data);
		this.password = String.orDefault(data.password);
		this.parent = Number.orDefault(data.parent);
		this.menu_order = Number.orDefault(data.menu_order);
	}

	public update(data: IWPPage) {
		super.update(data);
		if (data.password !== undefined) {
			this.password = String.orDefault(data.password);
		}
		if (data.parent !== undefined) {
			this.parent = Number.orDefault(data.parent);
		}
		if (data.menu_order !== undefined) {
			this.menu_order = Number.orDefault(data.menu_order);
		}
	}

	public restData() {
		let data = super.restData();
		if (this.password) {
			data.password = this.password;
		}
		if (this.parent) {
			data.parent = this.parent;
		}
		if (this.menu_order) {
			data.menu_order = this.menu_order;
		}
		return data;
	}
}
